module.exports = __webpack_public_path__ + "static/media/to.32d5e505.svg";